import { useGetRegionPageAvailableLooks } from 'api/regions/hooks';
import { useFetchLocationAvailableLooks } from 'api/locations/hooks';
import { useFetchRetailerPageAvailableLooks, useFetchStore } from 'api/store/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationLookAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableLooks(locationUid);

  return { items: data || [], isLoading };
};

export const useStoreLookAvailableItems = () => {
  const { data: store } = useFetchStore();
  const { data, isLoading } = useFetchRetailerPageAvailableLooks(store?.uid, {
    enabled: !!store?.uid,
  });

  return { items: data || [], isLoading };
};

export const useRegionLookAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableLooks(selectedRegion);

  return { items: data || [], isLoading };
};
